import { InnerContainer } from './components/InnerContainer/InnerContainer.js';
import { InnerDonut } from './components/InnerDonut/InnerDonut.js';
import type { InnerWrapperProps } from '../../types/internal/pie-chart.js';

export const InnerWrapper = ({
  width,
  height,
  innerRadius,
  visibleIds,
}: InnerWrapperProps) => {
  // Formula to calculate the maximum square inside a circle =  √2 × radius
  const donutInner = Math.sqrt(2) * innerRadius;

  return (
    <InnerContainer donutInner={donutInner} height={height} width={width}>
      <InnerDonut donutInner={donutInner} visibleIds={visibleIds} />
    </InnerContainer>
  );
};
